const Config = {
  baseApiUrl: "/api",
  MUILicenseKey:"401cbf7f1c9bfe7c42ccb7785561c4daTz01OTIzOSxFPTE3MDcyOTUxNDc5NDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=",
  SupervisorGroup : ["6efe65ca-403f-42d7-a53f-11e7bf929cdf"],
  Supervisor : 'supervisor'
  };
  
export default Config;
